<template>
  <Fragment>
    <div class="row mt-2 mt-md-3 mt-lg-4">
      <div class="col-12 col-md-6">
        <ReviewStepContainer :step="steps.fleetDetails">
          <FleetDetails />
        </ReviewStepContainer>

        <ReviewStepContainer :step="steps.tires">
          <Tires />
        </ReviewStepContainer>

        <ReviewStepContainer :step="steps.fuel">
          <Fuel />
        </ReviewStepContainer>
      </div>
      <div class="col-12 col-md-6">
        <ReviewStepContainer :step="steps.maintenance">
          <Maintenance />
        </ReviewStepContainer>

        <ReviewStepContainer :step="steps.roadCalls">
          <RoadCalls />
        </ReviewStepContainer>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <button class="btn btn-primary btn-hend" @click="onRestoreClick">
          Restore Industry Data
        </button>
      </div>
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';

import { mapGetters, mutation } from '../../store';
import FleetDetails from '../FleetDetails.vue';
import Fuel from '../Fuel.vue';
import Maintenance from '../Maintenance.vue';
import RoadCalls from '../RoadCalls.vue';
import Tires from '../Tires.vue';

import ReviewStepContainer from './ReviewStepContainer.vue';

export default {
  name: 'Review',

  components: {
    Fragment,
    ReviewStepContainer,
    FleetDetails,
    Tires,
    Fuel,
    Maintenance,
    RoadCalls,
  },

  computed: {
    ...mapGetters(['stepsSet']),

    /** @returns {StepsSet} */
    steps() {
      return this.stepsSet;
    },
  },

  methods: {
    onPrevious() {
      this.$store.commit(mutation('SET_PREVIOUS_STEP'));
    },

    onRestoreClick() {
      this.$store.commit(mutation('RESET_VALUES'));
    },
  },
};

/** @typedef {import('../../store/state').StepsSet } StepsSet */
</script>
